import { useState } from 'react'

import { useQuoteI18n } from '../quoteI18n'

/**
 * Schermata di sblocco del preventivo.
 *
 * Il link da solo non apre il preventivo: alla prima apertura viene recapitato un codice
 * di cinque cifre allo stesso destinatario, che va inserito qui. Serve a garantire che chi
 * apre la pagina controlli davvero l'indirizzo a cui il preventivo è stato mandato — un
 * link inoltrato, o finito nelle mani sbagliate, non basta.
 *
 * @param {Object} props
 * @param {number} props.attemptsLeft - Tentativi rimasti prima del blocco
 * @param {boolean} props.verifying - True mentre il codice viene verificato
 * @param {string} [props.error] - Messaggio dell'ultimo tentativo fallito
 * @param {(pin: string) => void} props.onSubmit - Verifica il codice inserito
 */
export function PinGate({ attemptsLeft, verifying, error, onSubmit }) {
  const { t } = useQuoteI18n()
  const [pin, setPin] = useState('')
  const blocked = attemptsLeft <= 0
  const canSubmit = !verifying && !blocked && pin.length === 5

  const handleSubmit = (event) => {
    event.preventDefault()
    if (!canSubmit) return
    onSubmit(pin)
  }

  return (
    <form className="gq-pin" onSubmit={handleSubmit}>
      <div className="gq-pin__icon" aria-hidden="true">
        🔒
      </div>
      <h2 className="gq-pin__title">{t.pin.title}</h2>
      <p className="gq-pin__text">{t.pin.text}</p>

      <input
        className="gq-pin__input"
        value={pin}
        onChange={(event) => setPin(event.target.value.replace(/\D/g, '').slice(0, 5))}
        inputMode="numeric"
        autoComplete="one-time-code"
        aria-label={t.pin.inputLabel}
        aria-invalid={!!error}
        disabled={blocked}
      />

      <p
        className="gq-pin__feedback"
        data-tone={error ? 'error' : 'muted'}
        role={error ? 'alert' : undefined}
      >
        {error || (blocked ? '' : t.pin.attemptsLeft(attemptsLeft))}
      </p>

      <button
        type="submit"
        className="gq-btn gq-btn--primary gq-btn--block gq-pin__submit"
        disabled={!canSubmit}
      >
        {verifying ? t.pin.verifying : t.pin.submit}
      </button>
    </form>
  )
}
